import { useState } from 'react';
import { C, SectionLabel, H2, wrap } from '../styles';

const faqs = [
  { q: 'Do I need technical drawings or CAD files?', a: "No. A hand sketch, a photo of a rough drawing, or even a napkin sketch is enough. The more detail you can give — approximate dimensions, material preference, intended use — the more precise the quote. We handle turning it into a professional brief." },
  { q: 'How fast do I get a quote?', a: "Once we've confirmed the specs with you, you get an accurate quote in under 72 hours. A photo or sketch is enough to start — we handle turning it into a professional brief." },
  { q: 'Who actually makes my parts?', a: "Your parts are produced through our network of 20+ established Ontario fabrication shops, each reviewed for capability and track record. You work with us as your single point of contact, from first quote to delivery." },
  { q: 'What if I need a prototype first, before a full production run?', a: "Prototype-first is one of the most common projects we handle. Just mention it in your submission and we'll line up shops experienced in low-volume prototype work." },
  { q: 'Is there any obligation after I get my quote?', a: 'None. Getting a quote is free and there is no commitment to proceed. Whether you move forward is entirely your decision.' },
];

export default function FAQ() {
  const [open, setOpen] = useState(null);
  const toggle = (i) => setOpen(open === i ? null : i);

  return (
    <section style={{ padding: '88px 0', borderTop: `1px solid ${C.bdr}`, background: C.surf }}>
      <div style={wrap}>
        <SectionLabel>Common questions</SectionLabel>
        <H2 style={{ marginBottom: 38 }}>What clients ask before they start</H2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {faqs.map((f, i) => (
            <div key={i} style={{ border: `1px solid ${open === i ? C.bdr2 : C.bdr}`, borderRadius: 7, overflow: 'hidden', transition: 'border-color 0.2s' }}>
              <button onClick={() => toggle(i)} style={{
                width: '100%', background: open === i ? C.surf3 : C.surf,
                border: 'none', padding: '18px 22px',
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                cursor: 'pointer', textAlign: 'left', transition: 'background 0.15s',
              }}>
                <span style={{ fontFamily: "'Instrument Sans', sans-serif", fontSize: 14, fontWeight: 600, color: C.txt }}>{f.q}</span>
                <span style={{ color: C.orange, fontSize: 20, flexShrink: 0, marginLeft: 14 }}>{open === i ? '−' : '+'}</span>
              </button>
              {open === i && (
                <div style={{ padding: '0 22px 18px', background: C.surf3 }}>
                  <p style={{ fontSize: 13, color: C.mut, lineHeight: 1.75, marginTop: 4 }}>{f.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
